// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\nsvg.big-logo {\n  inline-size: 80px;\n  block-size: 80px;\n}\n.border-align {\n  margin-top: 4px;\n}", ""]);
// Exports
module.exports = exports;
